import styled from '@emotion/styled';

import { maxWidthAndCenter, button } from '@styles';

const WhatWeDoContainer = styled.div`
  padding: 2rem 0 4rem;
  background-color: var(--orange);

  .what_we_do__content {
    ${maxWidthAndCenter}
    padding: 4rem 2rem 4rem 2rem;
    border-radius: 4rem;
    background: white;
    text-align: center;
    box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.25);

    h2 {
      font-size: 3rem;
      font-weight: 900;
      color: var(--blue);
    }

    hr {
      border-top-width: 0px;
      border-bottom-width: 4px;
      border-color: var(--orange);
      margin: 1rem auto;
      max-width: 10rem;
    }
  }

  .what_we_do__grid {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
  }

  .what_we_do__item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 2rem;
    max-width: 50%;

    h3 {
      margin: 1rem 0 0.5rem;
      font-size: 1.75rem;
      font-weight: 900;
      text-transform: uppercase;
      color: var(--orange);
    }

    pre {
      margin: 0;
    }

    p {
      color: var(--blue);
    }

    a {
      ${button('blue')}
      margin: 2rem 0 0 0;
      max-width: 17.5rem;
    }
  }

  @media screen and (max-width: 1500px) {
    .what_we_do__content {
      max-width: calc(100% - 4rem);
    }
  }

  @media screen and (max-width: 1152px) {
    .what_we_do__content {
      h2 {
        font-size: 2rem;
      }
    }

    .what_we_do__item {
      h3 {
        font-size: 1.25rem;

        pre {
          white-space: pre-wrap;
        }
      }
    }
  }

  @media screen and (max-width: 768px) {
    .what_we_do__item {
      padding: 2rem 0;
      max-width: 100%;
    }
  }
`;

export { WhatWeDoContainer };
